import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { BASE_URL } from "utils/constants";
import Swal from "sweetalert2";
import "./Schedual.css";

const DAY_ORDER = {
  Sunday: 1,
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
};

const DAY_SHORT = {
  Sunday: "Sun",
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
};

// Printing the rendered receipt only
const PrintElem = (id, isGrid = true) => {
  var mywindow = window.open("", "PRINT", "height=850,width=1200");
  var content = document.querySelector(`#${id}`)?.innerHTML;
  mywindow.document.write(`<!doctype html>
    <html lang="en">
      <head>
        <!-- Required meta tags -->
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">

        <!-- Bootstrap CSS -->
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">

        <title>Print Schedule</title>
        <style>
          @page {
            size: ${isGrid ? "landscape" : "auto"};
            margin: ${isGrid ? "6mm" : "10mm"};
          }
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            background: #ffffff !important;
            margin: 0 !important;
            padding: 8px !important;
            font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          }
          .grid-schedule-title {
            text-align: center;
            font-size: 24px;
            font-weight: 700;
            margin: 0 0 10px 0;
            color: #000000;
          }
          .grid-schedule-table, .classic-schedule-table {
            width: 100% !important;
            border-collapse: collapse !important;
            border: 2px solid #000000 !important;
            table-layout: fixed;
            background-color: #ffffff;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
          .grid-schedule-table th, .grid-schedule-table td,
          .classic-schedule-table th, .classic-schedule-table td {
            border: 1.5px solid #000000 !important;
            vertical-align: middle !important;
            box-sizing: border-box;
          }
          .grid-th-corner { width: 55px; background-color: #ffffff; }
          .grid-th-period { text-align: center; padding: 5px 2px; }
          .grid-period-number { font-size: 14px; font-weight: 700; }
          .grid-period-time { font-size: 9px; font-weight: 500; color: #222222; margin-top: 2px; white-space: nowrap; }
          .grid-td-day { font-size: 16px; font-weight: 700; text-align: center; width: 55px; background-color: #ffffff; padding: 4px 2px; }
          .grid-td-cell { height: 68px; padding: 2px; text-align: center; }
          .grid-cell-content { display: flex; flex-direction: column; justify-content: space-between; align-items: center; height: 100%; min-height: 62px; padding: 1px; gap: 2px; }
          .grid-course-name { font-size: 12px; font-weight: 700; color: #000; line-height: 1.15; word-break: break-word; text-align: center; width: 100%; }
          .grid-cell-meta { font-size: 10px; font-weight: 600; color: #111; line-height: 1.1; word-break: break-word; text-align: center; width: 100%; }
          .grid-cell-time { font-size: 8.5px; font-weight: 600; color: #333; line-height: 1; align-self: flex-end; white-space: nowrap; }
          .grid-cell-empty { height: 68px; background-color: #ffffff; }
          .grid-cell-multicard .grid-course-name { font-size: 13.5px; font-weight: 700; }
          .classic-schedule-table { width: 100% !important; border-collapse: collapse !important; border: 2.5px solid #000000 !important; }
          .classic-schedule-table thead th { background: #e9ecef !important; font-weight: 700 !important; color: #000000 !important; text-align: center !important; border: 1.5px solid #000000 !important; border-bottom: 3px solid #000000 !important; padding: 8px 6px !important; font-size: 13px !important; }
          .classic-schedule-table td, .classic-schedule-table th { border: 1.5px solid #000000 !important; padding: 6px 10px !important; vertical-align: middle !important; }
          .classic-schedule-table tr.day-start-row th, .classic-schedule-table tr.day-start-row td { border-top: 3.5px solid #000000 !important; }
          .classic-day-header { font-weight: 700 !important; text-align: center !important; background: #f8f9fa !important; border-right: 2.5px solid #000000 !important; border-left: 2px solid #000000 !important; }
          .no-print, .schedule-actions-bar, button { display: none !important; }
        </style>
      </head>
      <body>
        ${content}
        <script>
          window.onload = function() {
            window.focus();
            window.print();
          };
        </script>
      </body>
    </html>`);

  mywindow.document.close();
  return true;
};

const Schedual = () => {
  const permissions = useSelector((state) => state.permissions);
  const [viewMode, setViewMode] = useState("grid");
  const [scheduleData, setScheduleData] = useState({
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
  });
  const [configPeriods, setConfigPeriods] = useState([]);

  useEffect(() => {
    const fetchSchedule = async () => {
      Swal.showLoading();
      try {
        let res = await axios.post(`${BASE_URL}/student/getschedule.php`, {
          sId: permissions?.id,
        });

        const data = res?.data?.data || {};

        const sortLec = (arr) =>
          (arr || []).sort((a, b) =>
            Number(a.lecture) > Number(b.lecture) ? 1 : -1
          );

        setScheduleData({
          Sunday: sortLec(data.sun),
          Monday: sortLec(data.mon),
          Tuesday: sortLec(data.tue),
          Wednesday: sortLec(data.wed),
          Thursday: sortLec(data.thu),
        });

        if (Array.isArray(data.lecturetimes)) {
          setConfigPeriods(
            data.lecturetimes.map((lt) => ({
              lecture: Number(lt.lecture),
              time: lt.time || "",
            }))
          );
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Something Went Wrong", "", "error");
      } finally {
        Swal.close();
      }
    };

    fetchSchedule();
  }, [permissions?.id]);

  // Build period columns (all 10 periods guaranteed even if empty, or higher if lectures > 10)
  const periods = useMemo(() => {
    const periodMap = new Map();

    // 1. Seed from database lecturetimes
    configPeriods.forEach((cp) => {
      const num = Number(cp.lecture);
      if (!isNaN(num) && num > 0) {
        periodMap.set(num, cp.time || "");
      }
    });

    // 2. Also populate / update from actual schedule items
    Object.values(scheduleData)
      .flat()
      .forEach((item) => {
        const lectureNum = Number(item.lecture);
        if (!isNaN(lectureNum) && lectureNum > 0) {
          if (!periodMap.has(lectureNum) || (!periodMap.get(lectureNum) && item.time)) {
            periodMap.set(lectureNum, item.time || "");
          }
        }
      });

    // 3. Guarantee at least 10 periods across top
    let maxLecture = 10;
    periodMap.forEach((_, lecture) => {
      if (lecture > maxLecture) {
        maxLecture = lecture;
      }
    });

    // 4. Build complete consecutive periods 1 to maxLecture
    const list = [];
    for (let lec = 1; lec <= maxLecture; lec++) {
      list.push({
        lecture: lec,
        time: periodMap.get(lec) || "",
      });
    }

    return list;
  }, [scheduleData, configPeriods]);

  // Active days: Sunday - Thursday
  const activeDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"];

  const isDense = periods.length >= 8;
  const scheduleTitle = permissions?.fullname || permissions?.name || "Schedule";

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content mt-4">
        <h4 className="mt-4">Schedule</h4>

        {/* View Toggle and Print Bar */}
        <div className="schedule-actions-bar no-print">
          <div className="view-toggle-group">
            <button
              type="button"
              className={`view-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
              onClick={() => setViewMode("grid")}
            >
              Grid Timetable View
            </button>
            <button
              type="button"
              className={`view-toggle-btn ${viewMode === "classic" ? "active" : ""}`}
              onClick={() => setViewMode("classic")}
            >
              Classic View
            </button>
          </div>

          <button
            type="button"
            className="print-action-btn"
            onClick={() => {
              PrintElem("cont", viewMode === "grid");
            }}
          >
            <i className="fa fa-print" aria-hidden="true"></i>
            <span>Print</span>
          </button>
        </div>

        {/* Schedule Display Container */}
        <div id="cont" className="schedule-container w-100">
          {viewMode === "classic" ? (
            /* ==================================================== */
            /* CLASSIC LIST VIEW                                    */
            /* ==================================================== */
            <table className="classic-schedule-table">
              <thead>
                <tr>
                  <th style={{ width: "95px" }}>Day</th>
                  <th style={{ width: "140px" }}>Lecture (Time)</th>
                  <th>Course</th>
                  <th style={{ width: "95px" }}>Group</th>
                  <th style={{ width: "110px" }}>Classroom</th>
                  <th>Teacher</th>
                </tr>
              </thead>
              <tbody>
                {activeDays.map((day) => {
                  const dayLessons = scheduleData[day] || [];
                  if (dayLessons.length === 0) return null;

                  return dayLessons.map((sc, i) => (
                    <tr
                      key={`${day}-${sc.lecture}-${sc.id || i}`}
                      className={i === 0 ? "day-start-row" : ""}
                    >
                      {i === 0 ? (
                        <th
                          rowSpan={dayLessons.length}
                          className="classic-day-header"
                        >
                          {day}
                        </th>
                      ) : null}
                      <td>
                        Lecture {sc.lecture} {sc.time ? `(${sc.time})` : ""}
                      </td>
                      <td>{sc.coursename}</td>
                      <td>{sc.groupname || "-"}</td>
                      <td>{sc.classname || "-"}</td>
                      <td>
                        {sc.teacheremail ? (
                          <a
                            className="classic-teacher-link"
                            href={`mailto:${sc.teacheremail}`}
                          >
                            {sc.teachername}
                          </a>
                        ) : (
                          sc.teachername || "-"
                        )}
                      </td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          ) : (
            /* ==================================================== */
            /* GRID TIMETABLE VIEW                                  */
            /* ==================================================== */
            <div className={`grid-entity-page ${isDense ? "dense-schedule" : ""}`}>
              {/* Header Title */}
              <div className="grid-schedule-header">
                <h1 className="grid-schedule-title">{scheduleTitle}</h1>
              </div>

              {/* Grid Timetable Table */}
              <table className="grid-schedule-table">
                <thead>
                  <tr>
                    <th className="grid-th-corner"></th>
                    {periods.map((p) => (
                      <th key={p.lecture} className="grid-th-period">
                        <div className="grid-period-number">{p.lecture}</div>
                        {p.time && <div className="grid-period-time">{p.time}</div>}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {activeDays.map((day) => {
                    const dayItems = scheduleData[day] || [];
                    let skipCount = 0;

                    return (
                      <tr key={day}>
                        {/* 3-letter Day Abbreviation */}
                        <td className="grid-td-day">
                          {DAY_SHORT[day] || day.slice(0, 3)}
                        </td>

                        {/* Period Columns */}
                        {periods.map((p, pIndex) => {
                          if (skipCount > 0) {
                            skipCount--;
                            return null;
                          }

                          // Find starting lesson for this period
                          const lesson = dayItems.find(
                            (item) =>
                              String(item.lecture) === String(p.lecture) &&
                              !item.iscontinuation
                          );

                          if (lesson) {
                            const rawLength = Math.max(
                              1,
                              Number(lesson.blocklength ?? lesson.length ?? 1)
                            );
                            const cardLength = Math.min(
                              rawLength,
                              periods.length - pIndex
                            );

                            if (cardLength > 1) {
                              skipCount = cardLength - 1;
                            }

                            // Meta text: Teacher Name (Classroom)
                            const metaParts = [];
                            if (lesson.teachername) metaParts.push(lesson.teachername);
                            if (lesson.classname) metaParts.push(`(${lesson.classname})`);
                            const metaText = metaParts.join(" ");

                            return (
                              <td
                                key={p.lecture}
                                colSpan={cardLength}
                                className={`grid-td-cell ${
                                  cardLength > 1 ? "grid-cell-multicard" : ""
                                }`}
                              >
                                <div className="grid-cell-content">
                                  {lesson.time ? (
                                    <div className="grid-cell-time">{lesson.time}</div>
                                  ) : (
                                    <div></div>
                                  )}
                                  <div className="grid-course-name">
                                    {lesson.coursename || ""}
                                  </div>
                                  {metaText ? (
                                    <div className="grid-cell-meta">{metaText}</div>
                                  ) : (
                                    <div></div>
                                  )}
                                </div>
                              </td>
                            );
                          }

                          return (
                            <td
                              key={p.lecture}
                              className="grid-td-cell grid-cell-empty"
                            >
                              &nbsp;
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}

              {/* <tr>
                  <th scope="row">
                    Monday
                  </th>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleMon.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr>
                <tr>
                  <th scope="row">
                    Tuesday
                  </th>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleTue.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr>
                <tr>
                  <th scope="row">
                    Wednesday
                  </th>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleWed.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr>
                <tr>
                  <th scope="row">
                    Thursday
                  </th>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>Lecture {s.lecture}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>{s.classname}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>{s.coursename}</tr>
                    )
                  })}</td>
                  <td scope="row">{scheduleThu.map((s, key) => {
                    return (
                      <tr>{s.time}</tr>
                    )
                  })}</td>
                </tr> */}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Schedual;
